export const lendersData = [
  {
    href: '/lenders/mis-sold-alphera-car-finance',
    title: 'Alphera Finance',
  },
  {
    href: '/lenders/mis-sold-audi-car-finance',
    title: 'Audi Finance',
  },
  {
    href: '/lenders/mis-sold-barclays-car-finance',
    title: 'Barclays Finance',
  },
  {
    href: '/lenders/mis-sold-black-horse-car-finance',
    title: 'Black Horse',
  },
  {
    href: '/lenders/mis-sold-blue-motor-car-finance',
    title: 'Blue Motor Finance',
  },
  {
    href: '/lenders/mis-sold-bmw-car-finance',
    title: 'BMW Finance',
  },
  {
    href: '/lenders/mis-sold-ca-auto-car-finance',
    title: 'CA Auto Finance',
  },
  {
    href: '/lenders/mis-sold-close-brothers-car-finance',
    title: 'Close Brothers Finance',
  },
  {
    href: '/lenders/mis-sold-clydesdale-bank-car-finance',
    title: 'Clydesdale Bank',
  },
  {
    href: '/lenders/mis-sold-honda-car-finance',
    title: 'Honda Finance',
  },
  {
    href: '/lenders/mis-sold-hyundai-car-finance',
    title: 'Hyundai Finance',
  },
  {
    href: '/lenders/mis-sold-mercedes-car-finance',
    title: 'Mercedes Finance',
  },
  {
    href: '/lenders/mis-sold-moneybarn-car-finance',
    title: 'Moneybarn',
  },
  {
    href: '/lenders/mis-sold-motonovo-car-finance',
    title: 'Motonovo',
  },
  {
    href: '/lenders/mis-sold-northridge-car-finance',
    title: 'Northridge',
  },
  {
    href: '/lenders/mis-sold-psa-car-finance',
    title: 'PSA Finance',
  },
  {
    href: '/lenders/mis-sold-santander-car-finance',
    title: 'Santander',
  },
  {
    href: '/lenders/mis-sold-toyota-car-finance',
    title: 'Toyota Finance',
  },
  {
    href: '/lenders/mis-sold-vauxhall-car-finance',
    title: 'Vauxhall Finance',
  },
  {
    href: '/lenders/mis-sold-volkswagen-car-finance',
    title: 'Volkswagen Finance',
  },
]

export const vehicleMakesData = [
  {
    title: 'Audi',
    href: '/vehicles/audi-car-finance',
  },
  {
    title: 'BMW',
    href: '/vehicles/bmw',
  },
  {
    title: 'Ford',
    href: '/vehicles/ford',
  },
  {
    title: 'Honda',
    href: '/vehicles/honda',
  },
  {
    title: 'Hyundai',
    href: '/vehicles/hyundai',
  },
  {
    title: 'Mercedes-Benz',
    href: '/vehicles/mercedes',
  },
  {
    title: 'Nissan',
    href: '/vehicles/nissan',
  },
  {
    title: 'Toyota',
    href: '/vehicles/toyota',
  },
  {
    title: 'Vauxhall',
    href: '/vehicles/vauxhall',
  },
  {
    title: 'Volkswagen',
    href: '/vehicles/volkswagen',
  },
]

export const navigationItems = []

export const footerData = {
  company: {
    name: 'Your Claim Matters',
    description: '',
    legalInfo: '',
  },
  navigationLinks: [],
  links: [
    { title: 'Terms and Conditions', href: '/terms-and-conditions' },
    { title: 'Privacy Policy', href: '/privacy-policy' },
    { title: 'Cookie Policy', href: '/cookie-policy' },
    { title: 'Terms of Use', href: '/terms-of-use' },
    { title: 'Complaints Procedure', href: '/complaints-procedure' },
  ],
  social: [],
}
